import { MemberPositionHistory, PositionAssignmentStatus } from '@core/tellent-positions-types';

// TODO(positions-history): replace with real data once the backend contract for
// position history is finalized (behind the one_positions_history dev flag).
export function buildPositionHistoryMock(memberGuid: string): MemberPositionHistory {
  return {
    member: {
      guid: memberGuid,
      fullName: 'Joanna Dumithona',
      avatarThumbUrl: null,
    },
    scheduled: null,
    current: {
      id: 'current',
      positionGuid: 'mock-front-end-developer',
      positionName: 'Front-end Developer',
      startDate: '2025-06-01',
      status: PositionAssignmentStatus.Current,
    },
    previous: [
      {
        id: 'previous-1',
        positionGuid: 'mock-junior-front-end-developer',
        positionName: 'Junior front-end developer',
        startDate: '2024-12-01',
        status: PositionAssignmentStatus.Previous,
      },
      {
        id: 'previous-2',
        positionGuid: 'mock-intern',
        positionName: 'Intern',
        startDate: null,
        status: PositionAssignmentStatus.Previous,
      },
    ],
  };
}
